import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NxHeaderModule } from '@aposin/ng-aquila/header';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxLinkModule } from '@aposin/ng-aquila/link';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';

import { BusinessUnitSelectorComponent } from '#components/business-unit-selector/business-unit-selector.component';
import { LineOfBusinessSelectorComponent } from '#components/line-of-business-selector/line-of-business-selector.component';
import { LocaleSelectorComponent } from '#components/locale-selector/locale-selector.component';
import FeatureToggleService from '#services/featureToggle/featureToggle.service';
import UserService from '#services/user/user.service';

@UntilDestroy()
@Component({
  selector: 'kyc-header',
  imports: [
    NxHeaderModule,
    NxLinkModule,
    RouterLink,
    NxIconModule,
    NgOptimizedImage,
    TranslateModule,
    LocaleSelectorComponent,
    LineOfBusinessSelectorComponent,
    BusinessUnitSelectorComponent,
  ],
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  private readonly userService = inject(UserService);
  private readonly featureToggleService = inject(FeatureToggleService);

  protected readonly isLocaleSelectorEnabled = this.featureToggleService.getFeatureToggleSignal('translations');
  protected readonly isLineOfBusinessEnabled = this.featureToggleService.getFeatureToggleSignal('lob');

  protected readonly activeLineOfBusiness: string | undefined;

  protected get gadId(): string | undefined {
    return this.userService.getGadId();
  }
}
